module.exports = __webpack_public_path__ + "static/media/grandeDistrib.1a0d5b71.png";